export const environment = {
  production: true,
  baseUrl: 'https://www.vivest.com.br',
  baseUrlCdn: 'https://vivest-prd-cdn.azureedge.net',
  baseUrlScaf: 'https://www.vivest.com.br',
  baseUrlFacil: '	https://autorizacaofuncesp.facilinformatica.com.br',
  chaveFornecedor: 'ebcaca6a-31ae-4667-ab44-1dcf6d94b28c',
  secretPortal: '29ff1cf960bc6fe3a4bd29d22ba65dedffcc85f5a1d76d09ac825e6b0a047eba',
  secretPortalScaf: '29ff1cf960bc6fe3a4bd29d22ba65dedffcc85f5a1d76d09ac825e6b0a047eba',
  secretIR: 'VIVEST-DOCUMENTOS-IR-PRD',
  oacpScaf: '197dd8ab97194c9d80515991995ebe40',
  oacpInforme: 'd3030f2275194c4782d0e8e8b9ed1920',
  oacpSoftexpert: 'dea570f3de264ea7b674415190bbad2f',
  ocpDadosCadastrais: '03dd03050b5d41a69ddc5892d698df16',
  notificationsubscriptionkey: '6519e3f346954439bc3d9716078d3a84',
  featureId: 36
};
